export default "__VITE_ASSET__e1b80e09__"